import React from 'react';
import styles from '../layout/AdminLayout.module.css';

const HomeManagementComponent: React.FC = () => {
  return (
    <div className={styles.pageContainer}>
      <div>
        <b className={styles.pageTitle}>홈 관리</b>
      </div>
      
      <div className={styles.pageContent}>
        <p>홈 관리 기능을 구현해주세요.</p>
      </div>
    </div>
  );
};

export default HomeManagementComponent;
